/* Maison Dolce - selection de variantes multi-options */
(function () {
  "use strict";

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function money(c) {
    return (c / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
  }

  var dataEl = $("#variantData");
  if (!dataEl) return;
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!variants.length) return;

  var idInput = $("#variantId");
  var priceEl = $("#pricePrimary");
  var mainPriceEl = $("#mainPrice");
  var stockEl = $("#ppStock");
  var addBtn = $("#addCartBtn");
  var groups = $$("[data-opt-group]");
  if (!groups.length) return;

  var current = null;
  for (var i = 0; i < variants.length; i++) {
    if (idInput && String(variants[i].id) === String(idInput.value)) { current = variants[i]; break; }
  }
  if (!current) current = variants[0];
  var chosen = (current.options || []).slice();

  function match(sel) {
    for (var i = 0; i < variants.length; i++) {
      var o = variants[i].options || [];
      var ok = true;
      for (var j = 0; j < sel.length; j++) { if (o[j] !== sel[j]) { ok = false; break; } }
      if (ok) return variants[i];
    }
    return null;
  }

  /* une valeur est proposable si une combinaison dispo existe avec les autres choix courants */
  function reachable(optIndex, val) {
    for (var i = 0; i < variants.length; i++) {
      var o = variants[i].options || [];
      if (o[optIndex] !== val) continue;
      var ok = true;
      for (var j = 0; j < chosen.length; j++) {
        if (j === optIndex) continue;
        if (o[j] !== chosen[j]) { ok = false; break; }
      }
      if (ok && variants[i].available) return true;
    }
    return false;
  }

  function paint() {
    groups.forEach(function (g) {
      var gi = Number(g.getAttribute("data-opt-group"));
      $$(".swatch", g).forEach(function (sw) {
        var val = sw.getAttribute("data-val");
        sw.classList.toggle("active", chosen[gi] === val);
        sw.classList.toggle("is-out", !reachable(gi, val));
      });
      var lbl = $('[data-opt-label="' + gi + '"]');
      if (lbl) lbl.textContent = chosen[gi] || "";
    });
  }

  function apply(v) {
    if (!v) {
      if (stockEl) stockEl.hidden = true;
      if (addBtn) addBtn.disabled = true;
      return;
    }
    if (idInput) idInput.value = v.id;
    if (priceEl) priceEl.textContent = money(v.price);
    if (mainPriceEl) mainPriceEl.textContent = money(v.price);
    if (stockEl) stockEl.hidden = !v.available;
    if (addBtn) addBtn.disabled = !v.available;
    $$("[data-variant-row]").forEach(function (r) {
      r.classList.toggle("match", String(r.getAttribute("data-variant-row")) === String(v.id));
    });
    if (v.featured_index !== null && v.featured_index !== undefined && window.dolceGallery) {
      window.dolceGallery.go(v.featured_index);
    }
    try {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", v.id);
      window.history.replaceState({}, "", url);
    } catch (e) {}
  }

  groups.forEach(function (g) {
    g.addEventListener("click", function (e) {
      var sw = e.target.closest ? e.target.closest(".swatch") : null;
      if (!sw) return;
      var gi = Number(g.getAttribute("data-opt-group"));
      chosen[gi] = sw.getAttribute("data-val");
      var v = match(chosen);
      if (!v) {
        /* combinaison inexistante : on garde la valeur cliquee et on rabat les autres */
        for (var i = 0; i < variants.length; i++) {
          var o = variants[i].options || [];
          if (o[gi] === chosen[gi] && variants[i].available) { chosen = o.slice(); v = variants[i]; break; }
        }
      }
      paint();
      apply(v);
    });
  });

  paint();
  apply(current);
})();
